var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.errorIncognitoMode && !_vm.incognitoModeOn)?_c('div',[_c('IncognitoModeComponent')],1):_c('div',[_c('PaymentComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }